<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">The Jacobite Rising of 1715 and the Murray Family</h1>
<p class="sub-title">Brothers in Arms</p>
<p class="author">Rosalind Anderson</p>
<div class="img_container1">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?13c0a3a2